import React, { useEffect, useRef, useState } from "react";
import { Box, Card, Image, LoadingOverlay } from "@mantine/core";
import { getJobResults, pollJob } from "../api";
import ProcessingStatusBadge from "../ProcessingStatusBadge";
import { useStore } from "../store";
import { notifications } from "@mantine/notifications";

// TBD: Button bar, load in editor, delete, load config

// Currently, the card monitors the job status. This should change in the future when we allow people to
// queue multiple jobs (or have them run in parallel...)

export function ImageJobGenerateCard({ job }) {
  const timerIdRef = useRef(null);
  // 'waiting' in a generic sense -- i.e., is the user waiting for this job to complete?
  const [isWaiting, setIsWaiting] = useState(true);
  // 'polling' as in, are we actively polling the server for updates because this is processing server-side
  const [isPolling, setIsPolling] = useState(false);

  const galleryImages = useStore((state) => state.galleryImages);
  const setGalleryImages = useStore((state) => state.setGalleryImages);
  const jobs = useStore((state) => state.jobs);
  const setJobs = useStore((state) => state.setJobs);

  // const job = jobs.find((j) => j.clientId === jobClientId);

  useEffect(() => {
    if (job.status === "Queued" && isPolling === false) {
      console.debug(`Job ${job.clientId} queued, starting polling...`);
      setIsPolling(true);
    }
  }, [jobs]);

  const handleJobStatusChange = (polledJob) => {
    var jobStatus = "failed";

    if (polledJob && polledJob.status)
      jobStatus = polledJob.status.toLowerCase();
    console.debug(`polledJob ${polledJob.jobId} status is`, jobStatus);

    if (jobStatus === "waiting") {
      return;
    }

    if (jobStatus === "failed") {
      setIsPolling(false);
      setIsWaiting(false);
      notifications.show({
        title: "Job failed",
        message: "The job failed to complete. Please try again.",
        color: "red",
      });
      return;
    }

    if (jobStatus === "success") {
      console.debug("Job success, stopping polling", polledJob);
      setIsPolling(false);
      // get job results:
      getJobResults(polledJob.jobId).then((data) => {
        console.debug("Job results received", data);
        setGalleryImages((prev) => ({
          ...prev,
          data: [...data.results, ...prev.data],
        }));
        setIsWaiting(false);
      });
      return;
    }
  };

  useEffect(() => {
    const pollingCallback = () => {
      // nothing to poll?
      if (!job.jobId) return;

      pollJob(job.jobId)
        .then((data) => {
          // new: directly handle the status change. Used to go through another useEffect
          // cycle, but since we now have a job remover that no longer works...
          handleJobStatusChange(data);
          // Update jobs. This might trigger other updates, but that's fine.
          setJobs(
            jobs.map((p) => (p.jobId === job.jobId ? { ...p, ...data } : p))
          );
        })
        .catch((err) => {
          console.error("Polling failed!", err);
        });
    };

    const startPolling = () => {
      timerIdRef.current = setInterval(pollingCallback, 1500);
    };

    const stopPolling = () => {
      clearInterval(timerIdRef.current);
    };

    if (isPolling) {
      startPolling();
    } else {
      stopPolling();
    }

    return () => {
      stopPolling();
    };
  }, [isPolling, jobs]);

  return (
    <Card withBorder shadow="sm" radius="md">
      {/* <Card.Section>
        ID: {job.jobId}
      </Card.Section> */}
      <Card.Section>
        <Box pos="relative">
          <LoadingOverlay
            visible={isWaiting}
            zIndex={390} // 400 is the notifications, which should be on top
            overlayProps={{ blur: 4 }}
            loaderProps={{ children: <ProcessingStatusBadge job={job} /> }}
          />
          <Image src={job?.uri ?? "c1b.jpg"} />
        </Box>
      </Card.Section>

      {/* <Card.Section inheritPadding mt="sm" pb="md">
        {Object.entries(card.config).map(([k, v]) => {
          for(var entry of v) {
            return entry ? <Badge mr="xs" key={job?.jobId+k+entry}>{entry}</Badge> : null;
          }
        })}
      </Card.Section> */}
    </Card>
  );
}
